import useTranslation from 'next-translate/useTranslation'
import React, { useEffect } from 'react'
import useMatchTrucks from 'tennders-market/truck/hooks/useMatchTrucks'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import { filterByDistance } from 'tennders-stracture/libs/map'
import GLoading from 'tennders-market/common/components/element/GLoading'
import DistanceFilter from './DistanceFilter'
import MatchTransactions from './MatchTransactions'

const MatchTrucks = () => {
  const { truckToMatch, loading, fetchTrucks, trucks, setrange, range, dateRange, setdateRange } = useMatchTrucks()
  const { t } = useTranslation()

  const { transaction } = useTransaction()

  useEffect(() => {
    fetchTrucks(transaction?.id)
  }, [])

  return (
    <>
      {' '}
      <div className="d-flex justify-space align-center mb-20">
        <h3 className="bold mb-0 mr-10">{t('transaction:trucksMatched')}</h3>
        <DistanceFilter
          dateRange={dateRange}
          setdateRange={setdateRange}
          setrange={setrange}
          range={range}
        />
      </div>
      {loading ? <GLoading />
        : (
          <MatchTransactions
            type="truck"
            noMatchText={t('transaction:noTrucksToMatch')}
            onRefresh={fetchTrucks}
            transactions={filterByDistance(truckToMatch?.pickupRoute?.location, trucks, range)}
          />
        ) }
    </>
  )
}

export default MatchTrucks
